import i18n from '@/plugins/i18n';

import { inputWithMenuFilter } from '@/plugins/filters';
import { SETTINGS_OBJ } from '../../views/settings/const';
import { isBuildAvoidanceLicensed } from '../../globals/functions/licenseValidationRules';

export const Getters = {
  // implement getters here...

  // agentsLayout: (state) => {
  //   return state.agentsLayout;
  // },
  getInputsWithMenuSelectedOption: state => state.inputsWithMenuSelectedOption,
  getPortsToValidate: state => {
    const PortsToValidate = [SETTINGS_OBJ.Port, SETTINGS_OBJ.DashboardPort, SETTINGS_OBJ.LicensePort, SETTINGS_OBJ.CoordAPIPort];
    if (state.inputsData[SETTINGS_OBJ.AgentsUseSecureConnections]) PortsToValidate.push(SETTINGS_OBJ.SSLPort);
    return PortsToValidate;
  },
  getInputsData: state => state.inputsData,
  getDirtyState: state => state.dirtyState,
  getSettings: state => state.settingsFromCoord,
  getPortsValidations: state => state.portsValidations,
  getRexExpValidation: state => state.regExpValidation,
  getIgnoredProcessesList: state => {
    if (!state.settingsFromCoord || !state.settingsFromCoord.IgnoreProcesses || !(state.settingsFromCoord.IgnoreProcesses.length > 0)) return null;
    return state.settingsFromCoord.IgnoreProcesses.split(',');
  },
  licenseObj: state => state.license,
  enteredLicenseKeyValue: state => state.enteredLicenseKey,
  licensesObj: state => state.licenses,
  getSummaryObj: (state, getters) => {
    const inputsWithNumMap = {
      DAYS: ' DAYS',
      MON: ' MON',
      SEC: ' SEC',
      MIN: ' MIN',
      HRS: ' HRS',
      MB: ' MB',
      GB: ' GB',
      TB: ' TB',
    };
    //  last known selected option of the desire inputWithNumComponent field
    const curOptionSelected = state.inputsWithMenuSelectedOption;
    const inputsSelectedOption = {
      TelemetryDBMaxSize: curOptionSelected['telemetry-db-max-size-component'],
      TelemetryDaysToSave: curOptionSelected['telemtry-days-to-save-component'],
      MinDiskFree: curOptionSelected['disk-space-component'],
      MinVirtualMem: curOptionSelected['min-virtual-memory-component'],
      MinPhysicalMem: curOptionSelected['min-physical-memory-component'],
      FloatingReleaseTime: curOptionSelected['floating-release-time-component'],
      CacheCleanupInterval: curOptionSelected['time-period-space-component'],
      ReportInterval: curOptionSelected['report-interval-component'],
    };

    return {
      Agents: {
        Name: i18n.global.t('settings.summary.agents.title'),
        items: [
          {
            Name: i18n.global.t('settings.summary.agents.performance.title'),
            items: [
              {
                Name: i18n.global.t('settings.summary.agents.performance.cpuUsage.text'),
                Val: Math.round(Number(state.settingsFromCoord.MinIdleLevel)),
                Neon: true,
                addedLabel: ' %',
              },
              {
                Name: i18n.global.t('settings.summary.agents.performance.diskSpace.text'),
                Val: inputWithMenuFilter(state.settingsFromCoord.MinDiskFree, 'disksize', inputsSelectedOption.MinDiskFree),
                addedLabel: inputsWithNumMap[inputsSelectedOption.MinDiskFree],
              },
              {
                Name: i18n.global.t('settings.summary.agents.performance.virtualMemory.text'),
                Val: inputWithMenuFilter(state.settingsFromCoord.MinVirtualMem, 'disksize', inputsSelectedOption.MinVirtualMem),
                addedLabel: inputsWithNumMap[inputsSelectedOption.MinVirtualMem],
              },
              {
                Name: i18n.global.t('settings.summary.agents.performance.physicalMemory.text'),
                Val: inputWithMenuFilter(state.settingsFromCoord.MinPhysicalMem, 'disksize', inputsSelectedOption.MinPhysicalMem),
                addedLabel: inputsWithNumMap[inputsSelectedOption.MinPhysicalMem],
              },
              {
                Name: i18n.global.t('settings.summary.agents.performance.ignoreProcesses.text'),
                Val: !!state.settingsFromCoord.IgnoreProcesses,
              },
            ],
          },
          {
            Name: i18n.global.t('settings.summary.agents.license.title'),
            items: [
              {
                Name: i18n.global.t('settings.summary.agents.license.floatingReleaseTime.text'),
                Val: inputWithMenuFilter(state.settingsFromCoord.FloatingReleaseTime, 'timeForm', inputsSelectedOption.FloatingReleaseTime),
                addedLabel: inputsWithNumMap[inputsSelectedOption.FloatingReleaseTime],
              },
              {
                Name: i18n.global.t('settings.summary.agents.license.helperCore.text'),
                Val: state.settingsFromCoord.HelperCoresAssignmentPerc,
                addedLabel: ' %',
              },
              // todo - remove business logic from store
              isBuildAvoidanceLicensed(state.license)
                ? {
                    Name: i18n.global.t('settings.summary.agents.license.baAllocation.text'),
                    Val: state.settingsFromCoord.AutomaticBALicense,
                  }
                : null,
            ].filter(item => item),
          },
          {
            Name: i18n.global.t('settings.summary.agents.cache.title'),
            items: [
              {
                Name: i18n.global.t('settings.summary.agents.cache.scheduleTime.text'),
                Val: state.settingsFromCoord.RunCacheCleanup ? inputWithMenuFilter(state.settingsFromCoord.CacheCleanupInterval, 'timePeriod', inputsSelectedOption.CacheCleanupInterval) : null,
                addedLabel: inputsWithNumMap[inputsSelectedOption.CacheCleanupInterval],
              },
            ].filter(item => item),
          },
          // Temporarily removed until cache scheduling is implemented
          // {
          //   Name: i18n.global.t('settings.summary.agents.cache.title'),
          //   items: [
          //     {
          //       Name: i18n.global.t('settings.summary.agents.cache.scheduleTime.text'),
          //       Val: inputWithMenuFilter(state['settingsFromCoord'].CacheCleanupInterval, 'timePeriod', inputsSelectedOption.CacheCleanupInterval),
          //       addedLabel: inputsWithNumMap[inputsSelectedOption.CacheCleanupInterval],
          //     },
          //   ],
          // },
        ],
      },
      General: {
        Name: i18n.global.t('settings.summary.general.title'),
        items: [
          {
            Name: i18n.global.t('settings.summary.general.network.title'),
            items: [
              {
                Name: i18n.global.t('settings.summary.general.network.coordinatorPort.text'),
                Val: state.settingsFromCoord.Port,
              },
              {
                Name: i18n.global.t('settings.summary.general.network.uiPort.text'),
                Val: state.settingsFromCoord.DashboardPort,
              },
              {
                Name: i18n.global.t('settings.summary.general.network.serverPort.text'),
                Val: state.settingsFromCoord.CoordAPIPort,
              },
              {
                Name: i18n.global.t('settings.summary.general.network.licensePort.text'),
                Val: state.settingsFromCoord.LicensePort,
              },
              {
                Name: i18n.global.t('settings.summary.general.network.connectivity.text'),
                Val: inputWithMenuFilter(state.settingsFromCoord.ReportInterval, 'timeForm', inputsSelectedOption.ReportInterval),
                addedLabel: inputsWithNumMap[inputsSelectedOption.ReportInterval],
              },
              {
                Name: i18n.global.t('settings.summary.general.network.encryption.text'),
                Val: state.settingsFromCoord.AgentsUseSecureConnections,
              },
              state.settingsFromCoord.AgentsUseSecureConnections
                ? {
                    Name: i18n.global.t('settings.summary.general.network.SSLPort.text'),
                    Val: state.settingsFromCoord.SSLPort,
                  }
                : null,
              state.settingsFromCoord.AgentsUseSecureConnections
                ? {
                    Name: i18n.global.t('settings.summary.general.network.SslCnValidationPattern.text'),
                    Val: !!state.settingsFromCoord.SslCnValidationPattern,
                  }
                : null,
            ].filter(item => item),
          },
          /* {
            Name: i18n.global.t('settings.summary.general.database.title'),
            items: [
              {
                Name: i18n.global.t('settings.summary.general.database.timePeriod.text'),
                Val: inputWithMenuFilter(state['settingsFromCoord'].TelemetryDaysToSave, 'timePeriod', inputsSelectedOption.TelemetryDaysToSave),
                addedLabel: inputsWithNumMap[inputsSelectedOption.TelemetryDaysToSave],
              },
              {
                Name: i18n.global.t('settings.summary.general.database.hddSizeLimit.text'),
                Val: inputWithMenuFilter(state['settingsFromCoord'].TelemetryDBMaxSize, 'disksize', inputsSelectedOption.TelemetryDBMaxSize),
                addedLabel: inputsWithNumMap[inputsSelectedOption.TelemetryDBMaxSize],
              },
            ],
          }, */
          {
            Name: i18n.global.t('settings.summary.general.system.title'),
            items: [
              {
                Name: i18n.global.t('settings.summary.general.system.preventSysStandby.text'),
                Val: !state.settingsFromCoord.AllowSystemStandby,
              }, // flip because everybody is crazy
              {
                Name: i18n.global.t('settings.summary.general.system.dontShowWinFW.text'),
                Val: state.settingsFromCoord.IgnoreFirewall,
              },
              {
                Name: i18n.global.t('settings.summary.general.system.helpUsImprove.text'),
                Val: state.settingsFromCoord.TelemetryEnabled,
              },
            ],
          },
          {
            Name: i18n.global.t('settings.summary.general.coreLimit.title'),
            items: [
              {
                Name: i18n.global.t('settings.summary.general.coreLimit.forEachBuild.text'),
                Val: state.settingsFromCoord.MaxWorkers,
              },
            ],
          },
          {
            Name: i18n.global.t('settings.summary.general.backup.summarySection.title'),
            items: [
              {
                Name: i18n.global.t('settings.summary.general.backup.summarySection.isBackupConfiguredValueTitle'),
                Val: getters.isBackupCoordinatorConfigured,
              },
            ],
          },
          // {
          //   Name: i18n.global.t('settings.summary.general.telemetry.title'),
          //   items: [
          //     {
          //       Name: i18n.global.t('settings.summary.general.telemetry.helpUsImprove.text'),
          //       Val: state['settingsFromCoord'].TelemetryEnabled,
          //     },
          //   ],
          // },
        ],
      },

      // ** hidden till we have fields **
      // Cloud: {
      //   Name: i18n.global.t('settings.summary.cloud.title'),
      //   items: [
      //     { Name: 'XXXXXXX', Val: 'XXXXXXX' },
      //     { Name: 'XXXXXXXX', Val: 'XXXXXXXX' },
      //     { Name: 'XXXXXXXXX', Val: 'XXXXXXXXX' },
      //     { Name: 'XXXXXXXXXX', Val: 'XXXXXXXXX' },
      //   ],
      // },
      // ***************************************

      // 'Build Groups': [
      //   {Name: "xxx", Val: "xx"},
      //   {Name: "xxxy", Val: "xxx"},
      //   {Name: "xxxz", Val: "xxxx"},
      //   {Name: "xxxw", Val: "xxxxx"},
      // ],
      // Cloud: [
      //   {Name: "xxxxx", Val: "xxx"},
      //   {Name: "xxxxy", Val: "xxxx"},
      // ]
    };
  },
  // probably deprecated - pending deletion
  ignoredProcessesList:
    state =>
    (filterType = 0) => {
      // 0- Any, 1 - default, 2- regular
      if (filterType === 0) {
        // 0 - any
        return state.processesList;
      }
      // eslint-disable-next-line no-bitwise
      return state.processesList.filter(x => (filterType === 1 && x.keep) | (filterType === 2 && !x.keep));
    },

  getCloudUrl(state) {
    return state.cloudUrl;
  },
  getCloudStatus(state) {
    return state.cloudStatus;
  },

  // settingsList: (state) => {
  //   return state.settingsList;
  // },
  // settingsGetTypeConfig: (state) => (type) => {
  //   const typeSettings = state.settingsList[type];
  //   return typeSettings && typeSettings.Data ? typeSettings : null;
  // },
  // settingsGetTypeConfigData: (state) => (type) => {
  //   const typeSettings = state.settingsList[type];
  //   return typeSettings && typeSettings.Data ? typeSettings.Data : null;
  // },
  // settingsGetAgents: (state) => {
  //   const typeSettings = state.settingsList['Agents'];
  //   return typeSettings && typeSettings.Data ? typeSettings.Data : null;
  // },
};
